/**
 * Returns the bar size (0..1)
 *
 * @param {number} sum Total number of votes
 * @param {number} value Number of votes for the current option
 * @param {number} max Max number of votes for a single option
 * @returns float
 */
export function calculateBarSize(sum, value = 0, max, count) {
    return Math.min((sum / max) * (value / sum), 1) || 0;
}
